import React, { useRef } from 'react'
import { FaChevronRight } from 'react-icons/fa6'

function AccordionMenuItem({item, index, isOpen, currentKey, handleOpen, openedKey, renderItem}) {
  const containerHeight = useRef()
  return(
    <div className='menu-accordion rounded-lg' key={`${item.key}-${index}`}>
      <div 
        className={`
          flex items-center whitespace-nowrap justify-between cursor-pointer
          hover:bg-primary-200 pr-4 ${isOpen && openedKey === item.key ? 'bg-primary-100' : ''} 
          ${currentKey[0] ===  item.key ? 'primary-200' : ''}
        `}  
        onClick={(e) => handleOpen(item.key)}
      >
        <div className='flex items-center w-full rounded-lg'>
          {
            item.icon ?
            <>
              <span className='flex p-2'>{item.icon}</span>
              <span className='ml-3'>{item.label}</span>
            </>
            :
            <span className='p-2'>{item.label}</span>
          }
        </div>
        <FaChevronRight className={`transition-all duration-200 ${openedKey ===  item.key ? 'rotate-90' : 'rotate-0'}`}/>
      </div>
      <div
        ref={containerHeight}
        style={
          (openedKey ===  item.key && isOpen) ? 
          { height: containerHeight?.current?.scrollHeight } :
          { height: 0 }
        } 
        className={`menu-accordion-item bg-primary-100`}
      >
        {
          item.children.map((submenu, i) => renderItem({item: submenu, index: i, parentItem: item}))
        }
      </div>
    </div>
  )
}

export default AccordionMenuItem